// extracted by mini-css-extract-plugin
export default {"filtersContainer":"CompaniesTab_filtersContainer__RWI9f","searchFilterWrapper":"CompaniesTab_searchFilterWrapper__p7Ldh"};